import { Stack } from "@mui/material";
import styled from "styled-components";
import { theme } from "styles/mui-config";

export const StyledStack = styled(Stack)`
  background-color: ${theme.palette.secondary.light};
  border-radius: 4px;
  box-shadow: 0 0 5px ${theme.palette.shadow.main};
  margin-top: 30px;
  width: 100%;
  padding: 20px;
  padding-top: 15px;
`;

export const StyledTitle = styled.div`
  width: 100%;
  padding: 10px;
  padding-bottom: 20px;
  border-bottom: 2px solid ${theme.palette.primary.main};
  margin-bottom: 20px;
  font-family: IRANSans;
  font-weight: 500;
  font-size: 1.25rem;
  line-height: 1.6;
  color: gray;
`;
